import { gql } from '@src/__generated__';

export const GET_ITINERARY = gql(`
  query GetItinerary($tripProfileId: ID!) {
    getItinerary(tripProfileId: $tripProfileId) {
      date
      day
      amActivity
      amAttractionId
      amAttractionUrl
      amAttractionInterest
      pmActivity
      pmAttractionId
      pmAttractionUrl
      pmAttractionInterest
      dinner
      dinnerUrl
      accommodations
      accommodationsUrl
      notes
    }
  }
`);
